import { render, staticRenderFns } from "./WelcomeBack.vue?vue&type=template&id=1cf07ac0&scoped=true"
import script from "./WelcomeBack.vue?vue&type=script&lang=js"
export * from "./WelcomeBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf07ac0",
  null
  
)

export default component.exports